export enum RequestInitiatorType {
  /** Initiated by the HCP. */
  HCP = 'HCP',
  /** Automatically initiated as a consequence to a RPM event. */
  RPM_EVENT = 'RPM_EVENT',
  /** Like on-demand but initiated for one self. */
  SELF = 'SELF',
  /** Default. */
  SCHEDULE = 'SCHEDULE',
}
